<div class="modal-content">
  <div class="modal-header">
    <div class="d-flex align-items-center gap-3 flex-1">
      <h6 *ngIf="!isEdit" class="modal-title">
        <i class="far fa-user"></i><ng-container>&nbsp;</ng-container><ng-container i18n>Add User</ng-container>
      </h6>
      <h6 *ngIf="isEdit" class="modal-title">
        <i class="far fa-user"></i><ng-container>&nbsp;</ng-container><ng-container i18n>Edit User</ng-container>
      </h6>
      <div class="flex-fill"></div>
    </div>
    <a (click)="close()" class="cstm-close">
      <span class="far fa-times"></span>
    </a>
  </div>
  <div class="modal-body bg-none p-0">
    <form [formGroup]="form">
      <div class="text-light text-uppercase mb-3" i18n>User Information</div>
      <div class="row">
        <div class="col-md-3">
          <mat-form-field2 class="mat-block">
            <input
              type="text"
              formControlName="firstname"
              matInput
              required
              i18n-placeholder
              placeholder="First Name"
              autocomplete="off"
            />
            <mat-error *ngIf="form.get('firstname').touched && form.get('firstname').hasError('required')" i18n>
              First Name is required
            </mat-error>
            <mat-error
              *ngIf="form.get('firstname').touched && form.get('firstname').hasError('allNumbers')"
              class="text-nowrap"
            >
              <ng-container i18n>Cannot be numbers alone.</ng-container>
            </mat-error>
            <mat-error
              *ngIf="form.get('firstname').touched && form.get('firstname').hasError('minlength')"
              class="text-nowrap"
            >
              <ng-container i18n>At least 2 characters long</ng-container>
            </mat-error>
            <mat-error
              *ngIf="form.get('firstname').touched && form.get('firstname').hasError('maxlength')"
              class="text-nowrap"
            >
              <ng-container i18n>At most 50 characters long</ng-container>
            </mat-error>
            <mat-error *ngIf="form.get('firstname').hasError('name')" class="text-nowrap">
              <ng-container i18n>Only alphanumeric allowed.</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-3">
          <mat-form-field2 class="mat-block">
            <input
              type="text"
              formControlName="lastname"
              matInput
              required
              i18n-placeholder
              placeholder="Last Name"
              autocomplete="off"
            />
            <mat-error *ngIf="form.get('lastname').touched && form.get('lastname').hasError('required')" i18n>
              Last Name is required
            </mat-error>
            <mat-error *ngIf="form.get('lastname').hasError('allNumbers')" class="text-nowrap" i18n>
              Cannot be numbers alone.
            </mat-error>
            <mat-error *ngIf="form.get('lastname').hasError('minlength')" class="text-nowrap" i18n>
              At least 2 characters long
            </mat-error>
            <mat-error *ngIf="form.get('lastname').hasError('maxlength')" class="text-nowrap" i18n>
              At most 50 characters long
            </mat-error>
            <mat-error *ngIf="form.get('lastname').hasError('name')" class="text-nowrap" i18n>
              Only alphanumeric allowed.
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-6">
          <app-national-phone-input2 [ctrl]="form.get('phone')"></app-national-phone-input2>
        </div>
        <div class="col-md-6">
          <mat-form-field2 class="mat-block">
            <input
              type="email"
              formControlName="email"
              matInput
              required
              i18n-placeholder
              placeholder="Email"
              autocomplete="off"
            />
            <mat-error *ngIf="form.get('email').touched && form.get('email').hasError('required')" i18n>
              Email is required
            </mat-error>
            <mat-error *ngIf="form.get('email').touched && form.get('email').hasError('email')" i18n>
              Email must have valid format
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-6" *ngIf="form.get('attributes') as attrsCtrl">
          <label class="form-field-label" i18n>Gender</label>
          <div class="d-flex gap-3">
            <button
              class="btn flex-1"
              (click)="attrsCtrl.get('gender').setValue('female')"
              [ngClass]="attrsCtrl.get('gender').value == 'female' ? 'btn-indigo' : 'btn-outline-indigo'"
            >
              <i class="cs-icon cs-icon-female"></i> <ng-container i18n>Female</ng-container>
            </button>
            <button
              class="btn flex-1"
              (click)="attrsCtrl.get('gender').setValue('male')"
              [ngClass]="attrsCtrl.get('gender').value == 'male' ? 'btn-info' : 'btn-outline-info'"
            >
              <i class="cs-icon cs-icon-male"></i> <ng-container i18n>Male</ng-container>
            </button>
          </div>
        </div>
        <div class="col-md-6">
          <mat-form-field2 class="mat-block">
            <mat-select formControlName="role" i18n-placeholder placeholder="User Role" [required]="true">
              <mat-option
                *ngFor="let role of roles$ | async"
                [value]="role.value"
                [disabled]="isYearlyOC && role.value == roles.owner.value"
                [matTooltip]="role.tooltip"
                matTooltipPosition="right"
                >{{ role.label }}</mat-option
              >
            </mat-select>
            <mat-error *ngIf="form.get('role').touched && form.get('role').hasError('required')">
              <ng-container i18n>User Role is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-6">
          <app-language-select [ctrl]="form.get('attributes').get('language')"></app-language-select>
        </div>
      </div>
      <div class="row pt-3 border-top" formGroupName="address">
        <div class="col-md-12">
          <div class="text-light text-uppercase mb-3" i18n>User Location</div>
        </div>
        <div class="col-md-12">
          <mat-form-field2 class="mat-block">
            <input
              appGooglePlaces
              (onAddressChange)="onPlaceChange($event)"
              type="text"
              formControlName="address"
              matInput
              i18n-placeholder
              placeholder="Address"
            />
            <mat-error *ngIf="addressFrom.get('address').touched && addressFrom.get('address').hasError('minlength')">
              <ng-container i18n>Address must be at least 2 characters long</ng-container>
            </mat-error>
            <mat-error *ngIf="addressFrom.get('address').touched && addressFrom.get('address').hasError('maxlength')">
              <ng-container i18n>Address must be at most 140 characters long</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-6">
          <mat-form-field2 class="mat-block">
            <input type="text" formControlName="city" matInput i18n-placeholder placeholder="City" />
            <mat-error *ngIf="addressFrom.get('city').touched && addressFrom.get('city').hasError('minlength')" i18n>
              City must be at least 2 characters long
            </mat-error>
            <mat-error *ngIf="addressFrom.get('city').touched && addressFrom.get('city').hasError('maxlength')" i18n>
              City must be at most 50 characters long
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-6">
          <mat-form-field2 class="mat-block">
            <input
              type="text"
              formControlName="state"
              matInput
              i18n-placeholder
              placeholder="State / Province / Region"
            />
            <mat-error *ngIf="addressFrom.get('state').touched && addressFrom.get('state').hasError('minlength')" i18n>
              Value must be at least 2 characters long
            </mat-error>
            <mat-error *ngIf="addressFrom.get('state').touched && addressFrom.get('state').hasError('maxlength')" i18n>
              Value must be at most 50 characters long
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-6">
          <app-country-select
            [nameCtrl]="addressFrom.get('country')"
            [codeCtrl]="addressFrom.get('country_code')"
          ></app-country-select>
        </div>
        <div class="col-md-6">
          <mat-form-field2 class="mat-block">
            <input type="text" formControlName="postal_code" matInput i18n-placeholder placeholder="Postal Code" />
          </mat-form-field2>
        </div>
      </div>
      <div class="row pt-3 border-top" *ngIf="!isEdit">
        <div class="col-md-12">
          <div class="text-light text-uppercase mb-3" i18n>User Credentials</div>
        </div>

        <div class="col-md-6">
          <mat-form-field2 class="mat-block">
            <input
              i18n-matTooltip
              matTooltip="The password is created by the administrator when creating a user profile.  The user will be able to change their password once they log in."
              matTooltipPosition="above"
              type="password"
              formControlName="password1"
              matInput
              required
              i18n-placeholder
              placeholder="Password"
              autocomplete="off"
            />
            <mat-hint i18n>Minimum length of 8 characters</mat-hint>
            <mat-error *ngIf="form.get('password1').touched && form.get('password1').hasError('required')" i18n>
              Password is required
            </mat-error>
            <mat-error *ngIf="form.get('password1').touched && form.get('password1').hasError('minlength')" i18n>
              Password must be at least 8 characters long
            </mat-error>
          </mat-form-field2>
        </div>

        <div class="col-md-6">
          <mat-form-field2 class="mat-block">
            <input
              type="password"
              formControlName="password2"
              matInput
              required
              i18n-placeholder
              placeholder="Repeat Password"
              autocomplete="off"
            />
            <mat-error *ngIf="form.get('password2').touched && form.get('password2').hasError('required')" i18n>
              Password is required
            </mat-error>
            <mat-error *ngIf="form.get('password2').touched && form.get('password2').hasError('minlength')" i18n>
              Password must be at least 8 characters long
            </mat-error>
          </mat-form-field2>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer border-top" style="border-top-width: 2px !important">
    <button (click)="close()" type="button" class="btn btn-light">
      <i class="far fa-times"></i>
      <ng-container i18n>Cancel</ng-container>
    </button>
    <button (click)="isEdit ? onUpdate(form) : onCreate(form)" type="button" class="btn btn-secondary-info">
      <i class="cs-icon cs-icon-save"></i>
      <ng-container i18n>Save</ng-container>
    </button>
  </div>
</div>
